module.exports = __webpack_public_path__ + "static/media/face_expression_demo.ad295cb5.png";